import type { StudyStatus } from "@/routes/(app)/_app.study.$studyId"

export const setBreadcrumb = (type: StudyStatus): string => {
	if (type.toLowerCase().includes("kurs online")) {
		return "Szkolenie online"
	}
	return type
}